import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  Calendar, MapPin, Users, Globe, Trophy, Coffee,
  Sparkles, Heart, Mic, Code, ArrowUpRight, Play, X, Camera, CalendarDays
} from "lucide-react";
import PageBanner from '../PageBanner';

const eventsData = {
  previous: [
    {
      id: 1,
      title: "TECHRESOLVE CHALLENGE 3.0",
      type: "Hackaton",
      date: "2026-03-16",
      location: "ISIMS, Sfax",
      description: "The third edition of the TechResolve Challenge united innovators and developers in a National Technical Hackathon dedicated to solving global challenges through IT-driven solutions. Through collaboration, interactive workshops, and team-building activities, participants fostered creativity, expanded their networks, and delivered impactful technological innovations in an inspiring and friendly atmosphere.",
      image: "/asset/event/trc-3.webp",
      highlights: ["Hackaton", "Challenges", "Surprises", "Networking"],
      category: "Hackaton",
      attendees: 250,
      websiteUrl: "https://techresolve-challenge.com",
    },
    {
      id: 2,
      title: "IEEE ISIMS SB 6TH ANNIVERSARY",
      type: "Anniversary",
      date: "2026-02-18",
      location: "ISIMS, Sfax",
      description: "6 years, countless memories. From a small beginning to a thriving community, IEEE ISIMS SB has become a family of dreamers and changemakers. Every moment, every smile, and every challenge have shaped who we are today.",
      image: "/asset/event/anniv6.webp",
      highlights: ["Celebration", "Awards", "Networking", "Live Music"],
      category: "Anniversary",
      videoUrl: "https://www.instagram.com/reel/DVjncYDDNeN/",
      attendees: 80,
    },
    {
      id: 14,
      title: "EduBridge",
      type: "Celebration",
      date: "2025-04-12",
      location: "ENIS",
      description: "A dynamic gathering celebrating Education Week through insightful panel discussions, hands-on workshops, and a vibrant atmosphere of learning, collaboration, and community.",
      image: "/asset/event/edubridge.webp",
      highlights: ["Discussion", "Workshop", "Education"],
      category: "Social",
      attendees: 30
    },
    {
      id: 4,
      title: "Building Applications with Prompt Engineering",
      type: "Certification",
      date: "2026-02-28",
      location: "ISIMS, Sfax",
      description: "A successful NVIDIA certification session where participants explored prompt engineering and gained hands-on experience in building AI-powered applications.",
      image: "/asset/event/nvidiaa.webp",
      highlights: ["NVIDIA Certification", "Prompt Engineering", "Hands-on Labs"],
      category: "Technical",
      attendees: 50,
    },
    {
      id: 3,
      title: "TSYP13 National Congress",
      type: "Congress",
      date: "2025-12-22",
      endDate: "2025-12-24",
      location: "Hammamet, Tunisia",
      description: "The 13th Tunisian Students and Young Professionals Congress brought together young innovators for three days of workshops, competitions, and networking. A landmark event in Tunisian tech history.",
      image: "/heroieee1.webp",
      highlights: ["Awards Ceremony", "Workshops", "Networking", "Keynotes"],
      category: "Congress",
      attendees: 1200,
      videoUrl: "https://www.instagram.com/reel/DSxxKMyDOGd/"
    },
    {
      id: 5,
      title: "IEEE PLAY ON",
      type: "Celebration",
      date: "2026-04-05",
      location: "Touta Zoo Park",
      description: "Where passion meets performance : Celebrating strength, energy, and innovation this International Sports Day ",
      image: "/asset/event/touta.webp",
      highlights: ["Celebration", "Fun", "Sports Activities"],
      category: "Celebration",
      attendees: 28,
    },
    {
      id: 6,
      title: "IEEE Xtreme 19.0",
      type: "Competition",
      date: "2025-10-24",
      endDate: "2025-10-25",
      location: "Iyed Colab Sfax",
      description: "24-hour global coding marathon. Teams competed non-stop, solving complex algorithmic challenges. Pizza, caffeine, and code fueled the night.",
      image: "/asset/event/xtreme19.webp",
      highlights: ["24-hour Coding", "Global Competition", "Team Building", "Prizes"],
      category: "Technical",
      videoUrl: "https://www.instagram.com/reel/DQNdQo-kb21/",
      attendees: 100
    },
    {
      id: 7,
      title: "IEEE DAY 2025 Celebration",
      type: "Celebration",
      date: "2025-10-15",
      location: "IIT, Tunisia",
      description: "Over 165 attendees from IEEE ISIMS, IEEE ENIS, and IEEE IIT Student Branches came together for an unforgettable evening of inspiration and connection.",
      image: "/asset/event/ieeeday.webp",
      highlights: ["Keynote", "Panel", "Team Building", "After Party"],
      category: "Social",
      videoUrl: "https://www.instagram.com/reel/DR2m1-ojGcT/",
      attendees: 170,
    },
    {
      id: 8,
      title: "Code of Ethics Session",
      type: "Workshop",
      date: "2025-11-26",
      location: "ISIMS, Sfax",
      description: "Interactive session introducing the IEEE Code of Ethics with Mentimeter quiz and real-world case studies.",
      image: "/asset/event/codethics.webp",
      highlights: ["Interactive", "Live Quiz", "Case Studies", "Certificates"],
      category: "Social",
      attendees: 45,
    },
    {
      id: 9,
      title: "StepIn IEEE Volunteering 2026",
      type: "Session",
      date: "2025-11-19",
      location: "ISIMS, Sfax",
      description: "First session introducing members to upcoming volunteering opportunities and leadership roles within IEEE.",
      image: "/asset/event/volon.webp",
      highlights: ["Leadership Training", "Volunteering", "Networking"],
      category: "Social",
      attendees: 75
    },
    {
      id: 10,
      title: "AIoT Forum : Ideathon",
      type: "Forum",
      date: "2025-10-05",
      location: "ISIMS, Sfax",
      description: "Hybrid event exploring AIoT applications in smart cities, industry 4.0, and home automation.",
      image: "/asset/event/iot.webp",
      highlights: ["Bootcamp", "Visits", "Panel", "Pitch Competition"],
      category: "Technical",
      attendees: 50
    },
    {
      id: 11,
      title: "Pre-Xtreme 19.0 Training",
      type: "Training",
      date: "2025-10-11",
      location: "ISIMS, Sfax",
      description: "Intensive problem-solving session covering algorithms, data structures, and competitive programming strategies.",
      image: "/asset/event/cstraining.webp",
      highlights: ["Algorithms", "Data Structures", "Mock Competition"],
      category: "Technical",
      attendees: 35
    },
    {
      id: 12,
      title: "Industrial Visit to CRNS",
      type: "Visit",
      date: "2025-10-08",
      location: "CRNS, Sfax",
      description: "Exclusive tour of the Digital Research Center, exploring cutting-edge AI research and development.",
      image: "/asset/event/crns.webp",
      highlights: ["AI Research", "Lab Tour", "Expert Talks"],
      category: "Social",
      attendees: 40
    },
    {
      id: 13,
      title: "Industrial Visit to SNA",
      type: "Visit",
      date: "2025-10-01",
      location: "SNA Poulina, Tunisia",
      description: "Behind-the-scenes tour of automated production lines and digital supply chain management.",
      image: "/asset/event/sna.webp",
      highlights: ["Factory Tour", "Automation", "Industry 4.0"],
      category: "Social",
      attendees: 35
    },
  ]
};

const getEventIcon = (type) => {
  switch (type?.toLowerCase()) {
    case "conference": return <Globe className="w-3.5 h-3.5" />;
    case "workshop":   return <Mic className="w-3.5 h-3.5" />;
    case "bootcamp":   return <Code className="w-3.5 h-3.5" />;
    case "competition":return <Trophy className="w-3.5 h-3.5" />;
    case "hackathon":  return <Coffee className="w-3.5 h-3.5" />;
    case "anniversary":return <Sparkles className="w-3.5 h-3.5" />;
    case "celebration":return <Heart className="w-3.5 h-3.5" />;
    default:           return <Calendar className="w-3.5 h-3.5" />;
  }
};

const formatDate = (dateStr) => {
  const d = new Date(dateStr);
  return isNaN(d) ? dateStr : d.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" });
};

// Fixed modal — image left (wide), content right. No page scroll.
function EventModal({ event, onClose }) {
  React.useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = 'unset'; };
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-center justify-center p-4 sm:p-6 lg:p-8"
      onClick={onClose}
    >
      <motion.div
        initial={{ scale: 0.96, opacity: 0, y: 16 }}
        animate={{ scale: 1, opacity: 1, y: 0 }}
        exit={{ scale: 0.96, opacity: 0, y: 16 }}
        transition={{ type: "spring", damping: 28, stiffness: 320 }}
        className="relative w-full max-w-7xl h-[85vh] lg:h-[80vh] bg-white shadow-2xl flex flex-col lg:flex-row overflow-hidden rounded-none"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 z-30 w-10 h-10 bg-white/90 border border-[#006699]/20 flex items-center justify-center hover:bg-[#006699] hover:border-[#006699] hover:text-white transition-all duration-300 group rounded-none shadow-lg"
        >
          <X className="w-5 h-5 text-[#006699] group-hover:text-white" />
        </button>

        {/* LEFT — Image (Wider, Full Photo Visible) */}
        <div className="relative w-full lg:w-[65%] flex-shrink-0 h-[40%] sm:h-[45%] lg:h-full bg-[#f0f4f8]">
          {/* L corners */}
          <div className="absolute top-0 left-0 w-10 h-10 border-t-2 border-l-2 border-[#7dd3fc] z-10 pointer-events-none" />
          <div className="absolute bottom-0 right-0 w-10 h-10 border-b-2 border-r-2 border-[#7dd3fc] z-10 pointer-events-none" />

          {/* object-contain ensures the FULL width/height of the photo is visible without cropping */}
          <img src={event.image} alt={event.title} className="w-full h-full object-contain p-2 lg:p-4" />

          {/* Year + type badge */}
          <div className="absolute top-4 left-4 z-10">
            <span className="bg-[#006699] text-white text-[10px] sm:text-xs font-bold px-4 py-1.5 uppercase tracking-widest rounded-none shadow-md">
              {event.type}
            </span>
          </div>

          {/* Video Recap Link */}
          {event.videoUrl && (
            <a
              href={event.videoUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="absolute bottom-4 left-4 z-10 flex items-center gap-2 bg-[#006699] text-white text-[10px] sm:text-xs px-4 py-2 font-bold tracking-widest hover:bg-[#00334d] transition-all duration-300 rounded-none shadow-lg"
            >
              <Play className="w-3.5 h-3.5" /> WATCH RECAP ON INSTAGRAM
            </a>
          )}
        </div>

        {/* RIGHT — Content (fixed height, scrollable inside) */}
        <div className="flex flex-col flex-1 h-[60%] sm:h-[55%] lg:h-full p-6 sm:p-8 lg:p-10 overflow-y-auto bg-[#fafcff] custom-scrollbar border-l border-[#006699]/10">
          {/* Category */}
          <div className="flex items-center gap-2 mb-4 mt-2 lg:mt-0">
            <span className="w-6 h-[2px] bg-[#006699]" />
            <span className="text-xs font-bold text-[#006699] uppercase tracking-widest">{event.category || event.type}</span>
          </div>

          {/* Title */}
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-black text-[#00334d] leading-tight mb-6">
            {event.title}
          </h2>

          {/* Meta row */}
          <div className="flex flex-wrap items-center gap-5 mb-6 pb-6 border-b border-[#006699]/10">
            <span className="flex items-center gap-2 text-sm text-slate-500 font-semibold">
              <Calendar className="w-4 h-4 text-[#006699]" strokeWidth={2} />
              {formatDate(event.date)}{event.endDate && ` — ${formatDate(event.endDate)}`}
            </span>
            <span className="flex items-center gap-2 text-sm text-slate-500 font-semibold">
              <MapPin className="w-4 h-4 text-[#006699]" strokeWidth={2} />
              {event.location}
            </span>
            {event.attendees && (
              <span className="flex items-center gap-2 text-sm text-slate-500 font-semibold">
                <Users className="w-4 h-4 text-[#006699]" strokeWidth={2} />
                {event.attendees}+ attendees
              </span>
            )}
          </div>

          {/* Description */}
          <div className="flex-1 pr-2">
            <p className="text-sm sm:text-base text-slate-600 leading-relaxed">
              {event.description}
            </p>
            {/* Highlights */}
            {event.highlights && event.highlights.length > 0 && (
              <div className="mt-8">
                <p className="text-xs font-bold text-[#006699] uppercase tracking-widest mb-3">Highlights</p>
                <div className="flex flex-wrap gap-2.5">
                  {event.highlights.map((h, i) => (
                    <span key={i} className="text-xs font-semibold text-[#006699] bg-[#006699]/5 border border-[#006699]/15 px-3.5 py-1.5 uppercase tracking-wide rounded-none">
                      #{h}
                    </span>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* Bottom actions */}
          <div className="flex items-center gap-3 pt-6 mt-6 lg:mt-auto shrink-0">
            {event.websiteUrl && (
              <a
                href={event.websiteUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 bg-[#006699] hover:bg-[#00334d] text-white text-xs sm:text-sm font-bold px-6 py-3.5 uppercase tracking-widest transition-all duration-300 rounded-none w-full shadow-md"
              >
                <Globe className="w-4 h-4" /> Visit Website
              </a>
            )}
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
}

// Reusable Card Component
function EventCard({ event, variant, onClick, index }) {
  const isFeatured = variant === 'featured';
  const isMedium = variant === 'medium';
  const isNormal = variant === 'normal';

  // Responsive classes based on variant
  const imageAspect = isFeatured ? 'aspect-video lg:aspect-[21/9]' : isMedium ? 'aspect-video' : 'aspect-[4/3]';
  const titleSize = isFeatured ? 'text-2xl md:text-4xl' : isMedium ? 'text-xl sm:text-2xl' : 'text-lg leading-tight';
  const descSize = isFeatured ? 'text-base line-clamp-3' : isMedium ? 'text-sm line-clamp-3' : 'text-xs line-clamp-2';

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.05 }}
      className={`group cursor-pointer bg-white border border-[#006699]/10 hover:border-[#006699]/30 shadow-sm hover:shadow-[0_8px_30px_rgba(0,102,153,0.1)] transition-all duration-300 flex flex-col rounded-none h-full`}
      onClick={() => onClick(event)}
    >
      <div className={`relative w-full ${imageAspect} overflow-hidden bg-[#f0f4f8] shrink-0`}>
        {/* L-shaped borders */}
        <div className="absolute top-0 left-0 w-8 h-8 border-t-2 border-l-2 border-[#006699] z-20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" />
        <div className="absolute bottom-0 right-0 w-8 h-8 border-b-2 border-r-2 border-[#006699] z-20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" />

        <img
          src={event.image}
          alt={event.title}
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        
        {/* Category Badge */}
        <div className="absolute top-4 left-4 z-10">
          <span className={`bg-[#006699] text-white font-bold uppercase tracking-widest flex items-center gap-1.5 rounded-none shadow-md ${isFeatured ? 'px-4 py-2 text-xs' : 'px-3 py-1.5 text-[10px]'}`}>
            {getEventIcon(event.category)} {event.category}
          </span>
        </div>

        {event.videoUrl && (
          <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10 bg-black/20 pointer-events-none">
            <a 
              href={event.videoUrl}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
              className={`bg-[#006699] flex items-center justify-center rounded-none shadow-xl transform scale-90 group-hover:scale-100 transition-all duration-300 pointer-events-auto ${isFeatured ? 'w-16 h-16' : 'w-12 h-12'}`}
            >
              <Play className={`${isFeatured ? 'w-6 h-6' : 'w-5 h-5'} text-white fill-white ml-1`} />
            </a>
          </div>
        )}
      </div>
      
      <div className={`flex flex-col flex-1 ${isFeatured ? 'p-8 md:p-10' : isMedium ? 'p-6 md:p-8' : 'p-5'}`}>
        <h3 className={`${titleSize} font-black text-[#00334d] mb-4 group-hover:text-[#006699] transition-colors duration-300`}>
          {event.title}
        </h3>
        
        <p className={`text-slate-500 leading-relaxed mb-6 flex-1 ${descSize}`}>
          {event.description}
        </p>
        
        <div className="flex flex-wrap items-center justify-between pt-5 border-t border-[#006699]/10 mt-auto gap-4">
          <div className="flex flex-wrap items-center gap-4">
            <span className="flex items-center gap-1.5 text-xs font-semibold text-[#00334d]/60">
              <Calendar className="w-3.5 h-3.5 text-[#006699]" strokeWidth={2} /> 
              {formatDate(event.date)}
            </span>
            <span className="flex items-center gap-1.5 text-xs font-semibold text-[#00334d]/60">
              <MapPin className="w-3.5 h-3.5 text-[#006699]" strokeWidth={2} /> 
              <span className="truncate max-w-[120px]">{event.location}</span>
            </span>
          </div>
          
          <span className="text-[10px] font-bold text-[#006699] uppercase tracking-widest group-hover:mr-1 transition-all duration-300 flex items-center gap-1 shrink-0">
            VIEW <ArrowUpRight className="w-3 h-3" />
          </span>
        </div>
      </div>
    </motion.div>
  );
}

// Main Component
export default function Events() {
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [selectedFilter, setSelectedFilter] = useState("All");

  const categories = ["All", ...new Set(eventsData.previous.map(e => e.category))];
  
  const filteredEvents = selectedFilter === "All" 
    ? eventsData.previous 
    : eventsData.previous.filter(e => e.category === selectedFilter);

  // Divide events into hierarchy: 1 featured, up to 6 medium, remaining normal
  const featuredEvent = filteredEvents.length > 0 ? filteredEvents[0] : null;
  const mediumEvents = filteredEvents.slice(1, 7);
  const normalEvents = filteredEvents.slice(7);

  return (
    <div className="min-h-screen bg-[#fafcff] relative overflow-hidden">
      {/* TEXTURE PATTERN */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{ backgroundImage: `repeating-linear-gradient(-45deg, rgba(15, 105, 157, 0.02) 0px, rgba(15, 105, 157, 0.02) 1px, transparent 1px, transparent 18px)` }}
      />
      
      <PageBanner 
        title="Events" 
        description="Explore all the workshops, hackathons, competitions, and gatherings organized by IEEE ISIMS Student Branch." 
        Icon={CalendarDays} 
      />

      {/* Filter Bar */}
      <div className="relative z-10 bg-white border-b border-[#006699]/10">
        <div className="max-w-7xl mx-auto px-6 sm:px-10 py-5">
          <div className="flex flex-wrap gap-2">
            {categories.map(cat => (
              <button
                key={cat}
                onClick={() => setSelectedFilter(cat)}
                className={`px-5 py-2 text-xs font-bold uppercase tracking-widest border transition-all duration-300 rounded-none ${
                  selectedFilter === cat
                    ? 'bg-[#006699] border-[#006699] text-white'
                    : 'bg-white border-[#006699]/20 text-[#006699] hover:border-[#006699] hover:bg-[#006699]/5'
                }`}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>
      </div>
      
      <main className="relative z-10 max-w-7xl mx-auto px-6 sm:px-10 py-16 md:py-20">
        <AnimatePresence mode="wait">
          <motion.div 
            key={selectedFilter}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.4 }}
            className="flex flex-col gap-10 lg:gap-14"
          >
            {/* 1. Featured Event (Full width) */}
            {featuredEvent && (
              <div className="w-full">
                <EventCard event={featuredEvent} variant="featured" onClick={setSelectedEvent} index={0} />
              </div>
            )}

            {/* 2. Medium Events (3 per row) */}
            {mediumEvents.length > 0 && (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
                {mediumEvents.map((event, index) => (
                  <EventCard key={event.id} event={event} variant="medium" onClick={setSelectedEvent} index={index + 1} />
                ))}
              </div>
            )}

            {/* 3. Normal Events (4 per row) */}
            {normalEvents.length > 0 && (
              <>
                <div className="flex items-center gap-4 mt-4">
                  <span className="w-12 h-[2px] bg-[#006699]" />
                  <h3 className="text-sm font-bold text-[#00334d] uppercase tracking-widest">More Past Events</h3>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 lg:gap-6">
                  {normalEvents.map((event, index) => (
                    <EventCard key={event.id} event={event} variant="normal" onClick={setSelectedEvent} index={index + 7} />
                  ))}
                </div>
              </>
            )}
          </motion.div>
        </AnimatePresence>
        
        {filteredEvents.length === 0 && (
          <div className="text-center py-20">
            <p className="text-gray-500">No events found for this category.</p>
          </div>
        )}
      </main>
      
      {/* Event Modal */}
      <AnimatePresence>
        {selectedEvent && (
          <EventModal 
            event={selectedEvent} 
            onClose={() => setSelectedEvent(null)}
          />
        )}
      </AnimatePresence>
      
    </div>  
  );
}